<div class="cards-by-qr-rating-container px-3 gap-5 h-100 mb-3"
     [ngClass]="{'pb-5': isCreateReviewButtonVisible()}"
>
  <main class="card-by-qr-rating-container-content d-flex flex-column gap-3 position-relative pb-5">
    <!-- HEADER -->
    <div class="d-flex flex-row align-items-center gap-2 cards-by-qr-header py-4 px-3">
      <mat-icon class="d-flex align-items-center justify-content-center cursor-pointer"
                (click)="backToCard()">
        arrow_back
      </mat-icon>
      <span>{{ 'rating.all_reviews' | translate }} ({{ reviews.length }})</span>
    </div>

    <!-- USER CARD INFORMATION -->
    <div class="d-flex flex-row align-items-center gap-5">
      <!-- PICTURES -->
      <div class="position-relative">
        <img [src]="userCard && userCard.profilePic ? profilePicture : 'assets/svg/defaultUserIcon.svg'"
             alt="Profile picture"
             class="profile-picture"
             (error)="profilePicture = 'assets/svg/defaultUserIcon.svg'">
        @if (companyLogoExists) {
                          <img [src]="companyLogo" [alt]="'user_card.company_logo' | translate" class="company-logo">
        }
      </div>

      <!-- INFO -->
      <div class="d-flex flex-column ">
        <span class="full-name">{{ getFullName() }}</span>
        <span class="company-information">{{ getCompanyInformation() }}</span>
      </div>
    </div>

    <hr>

    <!-- RATINGS -->
    <div class="d-flex flex-column gap-2 px-3" *ngFor="let review of reviews"
         [ngClass]="{'editable-review-card': isReviewBelongsToCurrentUser(review)}"
         [class]="isReviewBelongsToCurrentUser(review) ? 'py-4' : 'py-2'"
    >
      <div class="d-flex flex-column gap-3">
        <div class="d-flex flex-row gap-3">
          <img [src]="review.profilePictureUrl ? review.profilePictureUrl : 'assets/svg/defaultUserIcon.svg'"
               alt="Profile picture"
               class="reviewer-profile-picture"
               (error)="review.profilePictureUrl = 'assets/svg/defaultUserIcon.svg'">
          <div class="d-flex w-100 flex-row justify-content-between">
            <span class="reviewer-name">{{ review.sender.fullName }}</span>
            <app-rating [rating]="review.rating"></app-rating>
          </div>
        </div>
        <span class="review-text">
          {{ getReviewDescription(review) }}
          @if (review.reviewText.length > REVIEW_DESCRIPTION_LENGTH) {
            <span class="review-text-more"
                  (click)="review.isShowMoreClicked = !review.isShowMoreClicked">{{ review.isShowMoreClicked ? ('rating.less' | translate) : ('rating.more' | translate) }}</span>
          }
        </span>
      </div>
      <span class="review-date">{{ review.createdAt | date:'dd.MM.yyyy' }}</span>

      @if (isReviewBelongsToCurrentUser(review)) {
        <div class="d-flex flex-row align-items-center w-100 gap-2">
          <button class="d-flex align-items-center gap-2 justify-content-center delete-review-button py-2"
                  (click)="onClickDeleteReview(review.id)"
          >
            <mat-icon class="delete-icon">delete_outline</mat-icon>
            {{ 'rating.delete' | translate }}
          </button>
          <button class="d-flex align-items-center gap-2 justify-content-center edit-review-button py-2"
                  (click)="redirectToManageReviewPage(review)"
          >
            <mat-icon>edit</mat-icon>
            {{ 'rating.edit' | translate }}
          </button>
        </div>
      }
    </div>
  </main>

</div>

@if (!isLeaveReviewButtonDisabled && !this.isCardBelongsToCurrentUser) {
  <div class="position-fixed bottom-0 footer-container">
    <footer class="cards-by-qr-footer">
      <button class="footer--black-button" (click)="handleReviewButtonClick()">
        {{currentUser ? ('rating.leave_review' | translate) : ('rating.signup_login_review' | translate) }}
      </button>
    </footer>
  </div>
}
